import apiClient, {timeouts} from 'shared/services/apiClient';
import {ManufacturerHealthCheckRespStatus, AnalysisTypeSelection, GetManufacturersResp, ManufacturersHealthCheckResp} from "../types";
import {endpoints} from "shared/services/endpoints";
import {fileService} from "shared/services/fileService";
import {SuccessResponse} from "shared/types/common";

export const healthcheckService = {
    getManufacturers: async () => {
        return apiClient
            .get<GetManufacturersResp>(endpoints.healthCheck.manufacturers, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as GetManufacturersResp)
            .catch((reason) => {
                return {manufacturers: [], errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as GetManufacturersResp;
            }
        );
    },

    getManufacturersHealthCheckResult: async (manufacturer_name_n: string) => {
        return apiClient
            .get<ManufacturersHealthCheckResp>(endpoints.healthCheck.results(manufacturer_name_n), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as ManufacturersHealthCheckResp)
            .catch((reason) => {
                return {status: ManufacturerHealthCheckRespStatus.NotChecked, full_list: 0, timestamp: 0, has_intersections: false, has_unexpected_kw: false, has_intersected_attrs: false, has_empty_rows: false, has_skipped_prods: false, has_broken_urls: false, has_broken_subs_urls: false, cat_sizes: [], intersections: [], unexpected_kw: [], intersected_attrs: [], empty_prods: [], skipped_prods: [], broken_urls: [], broken_subs_urls: [], errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as ManufacturersHealthCheckResp;
            }
        );
    },

    getManufacturersStatus: async (manufacturer_name_n: string) => {
        return apiClient
            .get<SuccessResponse>(endpoints.healthCheck.status(manufacturer_name_n), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as SuccessResponse)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SuccessResponse;
            }
        );
    },

    performHealthCheck: async (manufacturer_name_n: string, reanalyze_metrics: AnalysisTypeSelection[]|undefined) => {
        return apiClient
            .post<SuccessResponse>(endpoints.healthCheck.analyze, {manufacturer_name_n, reanalyze_metrics}, {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as SuccessResponse)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SuccessResponse;
            }
        );
    },

    exportGeneralResult: async (manufacturer_name_n: string) => {
        const endpoint_url = endpoints.healthCheck.generalExport(manufacturer_name_n);
        let filename = `${manufacturer_name_n}_general.xlsx`;
        return await fileService.downloadFile(endpoint_url, filename);
    },

    exportHealthCheckResult: async (manufacturer_name_n: string) => {
        const endpoint_url = endpoints.healthCheck.export(manufacturer_name_n);
        let filename = `${manufacturer_name_n}.xlsx`;
        return await fileService.downloadFile(endpoint_url, filename);
    },

    uploadCompressedCsv: async (manufacturer_name_n: string, file: File) => {
        const endpoint_url = endpoints.healthCheck.uploadCsv(manufacturer_name_n);
        return await fileService.uploadCompressedFile(endpoint_url, file);
    },
};
